<div class="d-flex dialog-body">
   <div class="dialog-align">
      <img alt="warning" src="/assets/Alert_box/warning_icon.svg" class="warning-icon">
   </div>
   <div class="body-container">
      <div class="message" *ngIf="!isWarningDialog && !data.isDuration">
         <span>File not supported</span>
         <p [hidden]="data.isVideo"> {{errorMessage}} </p>
         <p *ngIf="data.isVideo">File not supported. Video size exceeds 20MB limit. </p>
         <p>{{data.message}}</p>
      </div>
      
      <div class="message" *ngIf="!isWarningDialog && data.isDuration">
         <p>{{data.message}}</p>
      </div>

      <div class="message" *ngIf="isWarningDialog">
         <span *ngIf="data.warningTitle">{{data.warningTitle}}</span>
         <span *ngIf="!data.warningTitle">Warning</span>
         <p>{{data.message}}</p>
      </div>
      
      <div class="button-div">
         <button type="button" class="btn btn-default btn-grey" 
                 *ngIf="!isWarningDialog" 
                 mat-dialog-close>Okay</button>
         
         <ng-container *ngIf="isWarningDialog">
            <button type="button" class="btn btn-default btn-grey" 
                    style="margin-right: 8px;" 
                    (click)="onCancel()">No</button>
            <button type="button" class="btn btn-green" 
                    (click)="onProceed()">Yes</button>
         </ng-container>
      </div>
   </div>
   <img alt="close" src="/assets/Alert_box/close_icon.svg" mat-dialog-close class="close-icon">
</div>